/* eslint-disable react/jsx-no-target-blank */
import React, {useState, useEffect} from 'react';
import {useIntl} from 'react-intl';
import {KTSVG} from '../../../helpers';
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub';
import {AsideMenuItem} from './AsideMenuItem';
import {useAuth} from '../../../../app/modules/auth';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import {AuthModel} from '../../../../app/modules/auth/core/_models';
import {Buffer} from 'buffer';
import {requestPOST} from 'src/utils/baseAPI';

export function AsideMenuMain() {
  const intl = useIntl();
  const token = authHelper.getAuth()?.token;
  const tokenEncode = token.split('.')[1];
  const decodedToken = atob(token.split('.')[1]);
  const tokenObject = JSON.parse(decodedToken);
  const {currentUser} = useAuth();
  const [dataFolders, setDataFolders] = useState([]);
  const CheckRoleRoot = (role) => {
    if (!tokenObject?.permission) {
      return false;
    }
    return tokenObject?.permission?.includes(role);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await requestPOST(`api/v1/downloads/getfolder`, {path: ''});
        if (res) {
          setDataFolders(res);
        }
      } catch (error) {}
    };

    fetchData();

    return () => {};
  }, []);
  return (
    <>
      {(CheckRoleRoot('Permissions.Tenants.Create') || currentUser.userName == 'quantrimega') && (
        <AsideMenuItemWithSub
          to='/systems'
          title='Danh mục chung'
          icon='/media/icons/duotune/layouts/lay002.svg'
          fontIcon='bi-person'
        >
          <>
            <AsideMenuItem
              to='/systems/catalogues/registerapp'
              title='Thuê bao sử dụng phần mềm'
              hasBullet={true}
            />
          </>
        </AsideMenuItemWithSub>
      )}

      <AsideMenuItemWithSub
        to='/customers'
        title='Khách hàng'
        icon='/media/icons/duotune/layouts/lay001.svg'
        fontIcon='bi-person'
      >
        {(CheckRoleRoot('Permissions.Tenants.Create') || currentUser.userName == 'quantrimega') && (
          <>
            <AsideMenuItem to='/systems/manages/users' title='Đại lý ' hasBullet={true} />

            <AsideMenuItem
              to='/systems/catalogues/certificatelicenses'
              title='Danh sách chứng chỉ'
              hasBullet={true}
            />

            <AsideMenuItem
              to='/systems/catalogues/programlicenses'
              title='Danh sách phần mềm'
              hasBullet={true}
            />
          </>
        )}
        <AsideMenuItem
          to='/systems/catalogues/customeragencys'
          title='Danh sách khách hàng'
          hasBullet={true}
        />

        <AsideMenuItem
          to='/systems/catalogues/keylicenses'
          title='Danh sách key'
          hasBullet={true}
        />

        <AsideMenuItem
          to='/systems/catalogues/keylicenseinvoices'
          title='Lịch sử active key'
          hasBullet={true}
        />

        {/* <AsideMenuItem
          to='/systems/catalogues/tenants'
          title='Đăng ký tenants'
          hasBullet={true}
        />  */}
        {/* <AsideMenuItem
          to='/systems/catalogues/registerextendapp'
          title='Thuê bao hết hạn phần mềm (Admin)'
          hasBullet={true}
        /> */}
      </AsideMenuItemWithSub>

      {/* <AsideMenuItemWithSub
        to='/downloads'
        title='Các phiên bản phần mềm'
        icon='/media/icons/duotune/arrows/arr004.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItemWithSub
          to='/downloads'
          title='Danh sách phần mềm client'
          // icon='/media/icons/duotune/arrows/arr004.svg'
          fontIcon='bi-person'
        >
          {dataFolders.length > 0 &&
            dataFolders.map((item) => (
              <AsideMenuItem
                to={`/systems/downloads/clientdownloads_${item.name}`}
                title={`${item?.name}`}
                hasBullet={true}
              />
            ))}
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub> */}
    </>
  );
}
